export enum ConductFineStatuses {
  Cancelled = "CANCELLED",
  Issued = "ISSUED",
  Other = "OTHER",
  Paid = "PAID",
  Unpaid = "UNPAID",
}
